// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"fJ-z","carouselContainer":"gJ-z"};